<div id="add-edit-visita-empresa">
    <h2 class="m-b-5" mat-dialog-title>{{title}}</h2>
    <div mat-dialog-content>
        <form [formGroup]="visitaEmpresaForm">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="33">
                    <mat-form-field class="w-100-p">
                        <mat-label>F. Planificada</mat-label>
                        <input matInput [matDatepicker]="plannedDP" formControlName="PlannedDate" autocomplete="off"
                            [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="plannedDP"></mat-datepicker-toggle>
                        <mat-datepicker #plannedDP></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                        *ngIf="visitaEmpresaForm.get('PlannedDate').invalid && visitaEmpresaForm.get('PlannedDate').touched && !visitaEmpresaForm.get('PlannedDate').errors.required"
                        class="error-space">
                        <span>El formato de fecha no es válido (DD/MM/YYYY)</span>
                    </mat-error>
                    <mat-error
                        *ngIf="visitaEmpresaForm.get('PlannedDate').invalid && visitaEmpresaForm.get('PlannedDate').touched && visitaEmpresaForm.get('PlannedDate').errors.required"
                        class="error-space">
                        <span>Obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget" fxFlex.gt-sm="33">
                    <mat-form-field class="w-100-p">
                        <mat-label>F. Realizada</mat-label>
                        <input matInput [matDatepicker]="doneDP" formControlName="DoneDate" autocomplete="off"
                            (dateInput)="setMinMaxDates('T')">
                        <mat-datepicker-toggle matSuffix [for]="doneDP"></mat-datepicker-toggle>
                        <mat-datepicker #doneDP></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                        *ngIf="visitaEmpresaForm.get('DoneDate').invalid && visitaEmpresaForm.get('DoneDate').touched && !visitaEmpresaForm.get('DoneDate').errors.required"
                        class="error-space">
                        <span>El formato de fecha no es válido (DD/MM/YYYY)</span>
                    </mat-error>
                </div>
                <div class="widget" fxFlex.gt-sm="33">
                    <mat-form-field class="w-100-p">
                        <mat-label>Tipo</mat-label>
                        <mat-select formControlName="Type">
                            <mat-option *ngFor="let type of typeList$" [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="visitaEmpresaForm.get('Type').invalid && visitaEmpresaForm.get('Type').touched"
                        class="error-space">
                        <span>Obligatorio</span>
                    </mat-error>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Asistentes</mat-label>
                        <input matInput formControlName="Assistant" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget d-flex" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Asistentes de la Empresa</mat-label>
                        <input matInput formControlName="AsistentesEmpresa"  autocomplete="off">
                    </mat-form-field>
                    <button (click)="openAddEditPopup()" mat-icon-button class="navbar-toggle-button visit-emp-more">
                       <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19" >more_vert</mat-icon>
                    </button>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Asistentes de la Mutua</mat-label>
                        <input matInput formControlName="AsistentesMutua" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Asunto</mat-label>
                        <input matInput formControlName="Concept" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Comentarios</mat-label>
                        <textarea matInput formControlName="Comentarios"  autocomplete="off" rows="3"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                <div class="widget" fxFlex.gt-sm="100">
                    <mat-form-field class="w-100-p">
                        <mat-label>Resumen</mat-label>
                        <textarea matInput formControlName="Description" autocomplete="off" rows="3"></textarea>
                    </mat-form-field>
                    <mat-error
                        *ngIf="visitaEmpresaForm.get('Description').invalid && visitaEmpresaForm.get('Description').touched"
                        class="error-space">
                        <span>El número máximo de caracteres permitido es 500</span>
                    </mat-error>
                </div>
            </div> -->
        </form>
    </div>
    <div class="text-a-r  m-t-10 m-b-10">
        <button mat-raised-button color="accent" (click)="saveVisitaEmpresa()" class="m-r-15">Guardar</button>
        <button mat-raised-button (click)="cancel()" color="warn">Cancelar</button>
    </div>
</div>